export { filterCurriculumTree, getAllLv4Items } from './treeFilter'
export {
  normalizeText,
  containsNormalized,
  calculateRelevanceOptimized
} from './searchMatcher'
export { enrichLv4, collectLv4FromLv2, collectLv4FromLv3 } from './treeHelpers'
export type { FilteredLv4 } from './treeHelpers'
